"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _Button = _interopRequireDefault(require("../../browser/Button"));
var SubmitButton = function SubmitButton(_ref) {
  var loading = _ref.loading,
    payNow = _ref.payNow;
  var textId = payNow ? 'htmPayment.square.service.button.submit' : 'htmPayment.button.next';
  return _react["default"].createElement(_Button["default"], {
    disabled: loading,
    type: "submit",
    color: "green",
    size: "medium",
    width: "160px"
  }, _react["default"].createElement(_reactIntl.FormattedMessage, {
    id: textId
  }));
};
var _default = exports["default"] = SubmitButton;